import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

export const reportingApi = createApi({
  reducerPath: 'reportingApi',
  baseQuery,
  tagTypes: ['BidRankActivity', 'BidDeltaActivity', 'BidDeltaByLocation'],
  endpoints: (builder) => ({
    getBidRankActivity: builder.query({
      query: ({ portfolioId, startDate, endDate, facilityIds, filterTags }) => {
        const params = new URLSearchParams();
        params.append('portfolio_id', portfolioId);
        params.append('start_date', startDate);
        params.append('end_date', endDate);
        if (facilityIds && facilityIds.length > 0) {
          params.append('facility_ids', JSON.stringify(facilityIds));
        }
        if (filterTags && filterTags.length > 0) {
          params.append('filter_tags', JSON.stringify(filterTags));
        }
        return `/reporting/bid-rank-activity?${params.toString()}`;
      },
      transformResponse: (response) => response.result || response,
      providesTags: ['BidRankActivity'],
    }),
    getBidDeltaActivity: builder.query({
      query: ({ portfolioId, startDate, endDate, facilityIds, filterTags }) => {
        const params = new URLSearchParams();
        params.append('portfolio_id', portfolioId);
        params.append('start_date', startDate);
        params.append('end_date', endDate);
        if (facilityIds && facilityIds.length > 0) {
          params.append('facility_ids', JSON.stringify(facilityIds));
        }
        if (filterTags && filterTags.length > 0) {
          params.append('filter_tags', JSON.stringify(filterTags));
        }
        return `/reporting/bid-delta-activity?${params.toString()}`;
      },
      transformResponse: (response) => response.result || response,
      providesTags: ['BidDeltaActivity'],
    }),
    getBidDeltaByLocation: builder.query({
      query: ({ portfolioId, startDate, endDate, facilityIds, filterTags }) => {
        const params = new URLSearchParams();
        params.append('portfolio_id', portfolioId);
        params.append('start_date', startDate);
        params.append('end_date', endDate);
        if (facilityIds && facilityIds.length > 0) {
          params.append('facility_ids', JSON.stringify(facilityIds));
        }
        if (filterTags && filterTags.length > 0) {
          params.append('filter_tags', JSON.stringify(filterTags));
        }
        return `/reporting/bid-delta-by-location?${params.toString()}`;
      },
      transformResponse: (response) => response.result || response,
      providesTags: ['BidDeltaByLocation'],
    }),
  }),
});

export const {
  useGetBidRankActivityQuery,
  useGetBidDeltaActivityQuery,
  useGetBidDeltaByLocationQuery,
} = reportingApi;
